import { Container, ContainerOptions, Sprite, Text } from "pixi.js";
import { JackpotHitData } from "../models/JackpotHitData";
import i18next from "i18next";

export class MarqueeJpHistoryItem extends Container {
  private data: JackpotHitData;
  private dateText: Text;
  private locationText: Text;
  private valueText: Text;
  private textSpacing: number = 10;

  constructor(jpHitData: JackpotHitData, containerOpts?: ContainerOptions) {
    super(containerOpts);
    this.data = jpHitData;

    const fontFamily: string = "Avenir Next Condensed Demi Bold";

    this.dateText = new Text({
      text: this.data.timestamp.toLocaleDateString(),
      style: {
        fontFamily: fontFamily,
        fontSize: 40,
        fill: 0xffffff,
      },
    });
    this.dateText.y = 20;
    // this.dateText.anchor.set(0, 1);
    this.locationText = new Text({
      text: `${this.data.location} -`,
      style: {
        fontFamily: fontFamily,
        fontSize: 60,
        fill: 0xffffff,
      },
    });
    // this.locationText.anchor.set(0, 1);
    const formatted = new Intl.NumberFormat(i18next.language, {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(this.data.value);

    this.valueText = new Text({
      text: formatted,
      style: {
        fontFamily: fontFamily,
        fontSize: 60,
        fill: 0xf2e476,
      },
    });
    // this.valueText
    // this.valueText.anchor.set(0, 1);

    this.addChild(this.dateText);
    this.addChild(this.locationText);
    this.addChild(this.valueText);

    // this.addChild(Sprite.from("_plonk_jackpot"));
    this.sortFields();
  }

  private sortFields = (): void => {
    this.dateText.x = 0;
    this.locationText.x = this.dateText.width + this.textSpacing;
    this.valueText.x =
      this.locationText.x + this.locationText.width + this.textSpacing;
  };
}
